import type { RouteLocationNormalizedLoaded } from 'vue-router';

export type PlatformModule
  = 'assistant'
    | 'experts'
    | 'resources'
    | 'automation'
    | 'apps'
    | 'dev';

export type ResourceTab = 'skills' | 'connectors' | 'knowledge';

export interface PlatformNavItem {
  key: PlatformModule;
  path: string;
  i18nKey: string;
  icon: string;
  perm: string;
}

export const RESOURCE_TABS: ResourceTab[] = ['skills', 'connectors', 'knowledge'];

export const PLATFORM_NAV_ITEMS: PlatformNavItem[] = [
  { key: 'assistant', path: '/chat', i18nKey: 'platformNav.assistant', icon: 'message', perm: 'chat:nav:assistant' },
  { key: 'experts', path: '/experts', i18nKey: 'platformNav.experts', icon: 'users', perm: 'chat:nav:experts' },
  { key: 'apps', path: '/apps', i18nKey: 'platformNav.apps', icon: 'grid', perm: 'chat:nav:apps' },
  { key: 'automation', path: '/automation', i18nKey: 'platformNav.automation', icon: 'clock', perm: 'chat:nav:automation' },
  { key: 'resources', path: '/resources', i18nKey: 'platformNav.resources', icon: 'collection', perm: 'chat:nav:resources' },
  { key: 'dev', path: '/dev', i18nKey: 'platformNav.dev', icon: 'code', perm: 'chat:dev' },
];

export const NAV_PERM_CODES = PLATFORM_NAV_ITEMS
  .filter(item => item.key !== 'dev')
  .map(item => item.perm);

export function isResourceTab(value: unknown): value is ResourceTab {
  return typeof value === 'string' && (RESOURCE_TABS as string[]).includes(value);
}

export function resolveResourceTab(route: RouteLocationNormalizedLoaded): ResourceTab {
  const raw = route.query.tab;
  const tab = Array.isArray(raw) ? raw[0] : raw;
  return isResourceTab(tab) ? tab : 'skills';
}

export function resolvePlatformModule(route: RouteLocationNormalizedLoaded): PlatformModule {
  return moduleForPath(route.path) ?? 'assistant';
}

/** 侧栏权限守卫用：非模块页（通知、登录、403 等）返回 null，不拦截。 */
export function moduleForPath(path: string): PlatformModule | null {
  if (path.startsWith('/resources') || path.startsWith('/knowledge') || path.startsWith('/skills') || path.startsWith('/connectors'))
    return 'resources';
  if (path.startsWith('/apps'))
    return 'apps';
  if (path.startsWith('/automation') || path.startsWith('/task/'))
    return 'automation';
  if (path.startsWith('/experts'))
    return 'experts';
  if (path.startsWith('/dev'))
    return 'dev';
  if (path === '/' || path === '/chat' || path.startsWith('/chat/'))
    return 'assistant';
  return null;
}

export function getPlatformModuleLabelKey(module: PlatformModule): string {
  const item = PLATFORM_NAV_ITEMS.find(nav => nav.key === module);
  return item?.i18nKey ?? 'platformNav.assistant';
}
